import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import classNames from "classnames";
import intl from "react-intl-universal";


import {InfoIcon} from "../../icons/InfoIcon";
import {Button} from "../../Button";


import "./CalendarSelect.css";


export interface CalendarSelectRepeatOptionsProps {
    getSelectedDates: () => number[];
    onChange: (dates: number[]) => void;
}

export const CalendarSelectRepeatOptions = observer(
    ({
         getSelectedDates,
         onChange
     }: CalendarSelectRepeatOptionsProps
    ) => {
        const [localDates, setLocalDates] = useState<number[]>(getSelectedDates());

        useEffect(() => {
            setLocalDates(getSelectedDates());
        }, [getSelectedDates]);

        const toggleDay = (day: number) => {
            const updated = localDates.includes(day)
                ? localDates.filter((d) => d !== day)
                : [...localDates, day].sort((a, b) => a - b);

            setLocalDates(updated);
            onChange(updated);
        };

        const days = Array.from({length: 31}, (_, i) => i + 1);

        return (
            <div className="Calendar__Repeat__Month">
                <div className="Calendar__Repeat__Month--days">
                    {days.map((day) => (
                        <div
                            key={day}
                            className={classNames({
                                "Calendar__Repeat__Month__day body-small": true,
                                "Calendar__Repeat__Month--active": localDates.includes(day),
                                "Calendar__Repeat__Month__endDays": day >= 29,
                            })}
                            onClick={() => toggleDay(day)}
                        >
                            {day}
                        </div>
                    ))}
                </div>
                <Button
                    className={"Calendar__Repeat__Month__Button"}
                    text={intl.get("Calendar-Repeat.Month.button").d("Clear All")}
                    type="primary"
                    style="inline"
                    size="sm"
                    onClick={() => {
                        setLocalDates([]);
                        onChange([]);
                    }}
                />
                <div className="CalendarRepeat__Footer body-small">
                    <InfoIcon size={16} className={"CalendarRepeat__Footer__icon"}/>
                    {intl.get('CalendarRepeat.options.footer').d(`*Scheduled on the last day of the month if selected day doesn't exist.`)}
                </div>
            </div>
        );
    }
);
